<mat-form-field appearance="fill" color="primary" class="w-100 procedure-field-renderer">
  @if (control().hasLabel && !control().inline) {
    <mat-label [style.color]="control().labelColour">{{ control().label }}</mat-label>
  }
  @if (control().hasLabel && control().inline) {
    <span class="mat-bold mat-opacity-7 me-2" style="white-space: normal" matPrefix [style.color]="control().labelColour">{{ control().label }}</span>
  }
  <input matInput xuiTextareaJumptext [style.color]="control().valueColour" placeholder="{{ control().placeHolder }}" [(ngModel)]="control().value" (ngModelChange)="onValueChanges()">
  @if (control().hasUnits) {
    <span matSuffix [style.color]="control().valueColour">{{ control().units }}</span>
  }
</mat-form-field>
